class CPTagsAggregator {
    constructor(contents) {
        this.list = this.extract(contents, 'tags')
        this.list = this.sort(this.list)
    }

    extract(contents) {
        let result = []
        contents.map((content) => {
            content.tags.map(tag => {
                const findItem = result.find((item) => item.id == tag)
                if (findItem) {
                    findItem.count += 1
                } else {
                    result.push({ "id": tag, "name": tag, "count": 1 })
                }
            })
        })
        return result
    }

    sort(unsortedList) {
        return unsortedList.sort((a, b) => b.count - a.count)
    }
}

export default CPTagsAggregator